module.exports = __webpack_public_path__ + "img/ali-example.71c73b85.jpg";